<template>
<div class="modal h-100" ref="modal" id="settings" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document" :style="licenseExpMess && licenseExpMess.trim().length?'height:calc(100% - 30px)':'height:100%'">
    <div class="modal-content full-screen-settings">
      <div class="modal-header p-2">
        <h4 class="modal-title mt-2 ml-2">{{$t('Reports')}}</h4>
        <button type="button" class="close text-white" data-dismiss="modal" :style="close" aria-label="Close" @click="close" :isSettings="showSettings">
          <span aria-hidden="true"><h2><cancel-icon class="close-icon" style="height: 35px !important;
    width: 35px !important;
    color: #fff;"></cancel-icon></h2></span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="container-fluid sidenav">
                    <div style="height:inherit;display:inline-flex;width:100%">
                      <div class="col-md-2 h-100 p-0" :style="[ isFullScreen ? {display: 'none'}: {display: 'block'}]">
                        <nav class="sidebar-wrapper h-100">
                        <ul class="sidebar-menu m-0 h-100" style="list-style-type:none;padding:4px;overflow: auto;">
                          <li class="sidebar text-left" v-for="panel in getRegisteredReportsSidemenu()" :class="{activeclass:activeIndex == panel.id}" :id="panel.id" v-on:click="getEventHandler('onClick',panel.onEvents, panel)" :key="panel.label">
                              <span class="m-0 option-label"><span v-html="panel.iconSvgCallback('','20px','20px')" style="margin-inline-end:10px;position: relative;bottom: 3px;"></span>{{$t(panel.label)}}</span>
                          </li>
                        </ul>
                        </nav>
                      </div>
                      <div class="p-0 h-100 col-md-10" :class="[ isFullScreen ? 'col-md-12' : 'col-md-10']">
                          <router-view :name="selectedComponent" v-bind="currentProperties" v-on:fullscreenDisplayRequest="openFullScreen" class="h-100"></router-view>
                      </div>
                    </div>
                </div>
      </div>
     <!-- <Footer></Footer> -->
    </div>
  </div>
</div>
</template>

<script>
// import Footer from "../core/Footer.vue";
import Utils from "../../components.utils.js"
import {mapMutations,mapGetters, mapActions} from "vuex"
import cancelIcon from "../core/InlineCancelField.vue"
import {ReportsSidemenu} from "../../registry/plugins.js"

export default {
  components:{
      'cancel-icon':cancelIcon,
      // Footer
    },
    computed:{
      currentProperties() {
        if (this.selectedComponent === "external-reports-plugin-loader") {
            return { pluginInfo : this.selectedPluginInfo};
        }
        else{
            return {}
        }
      },
    },
    watch:{
      "$route.fullPath":function(newVal,oldVal){
        if (newVal!=oldVal){
          if (this.$route.matched[this.$route.matched.length-1].parent.name == "reports" && this.selectedComponent != this.$route.name){
            if(this.$route.name == "pipeline-report"){
              this.changeToSelectedComponent(this.$route.name, this.$route.params.stageId, false)
            }else{
              this.changeToSelectedComponent(this.$route.name, this.$route.params.pluginId?this.$route.params.pluginId:this.$route.name.split("-")[0], false)
            }
          }else if(this.selectedComponent == "pipeline-report"){
            if(this.$route.params && 'stageId' in this.$route.params && this.activeIndex != this.$route.params.stageId){
              this.activeIndex = this.$route.params.stageId
            }
          }
        }
      }
    },
    methods:{
        changeToSelectedComponent(compName,id, push=true){
          console.log("compNamecompName",compName,id)
            this.selectedComponent = compName;
            this.activeIndex = id;
            let route = {name: compName}
            if (this.selectedComponent == "external-reports-plugin-loader" && id){
              route.params = {pluginId: id}
            }else if(this.selectedComponent == "pipeline-report"){
              route.params = {stageId: id}
              this.isFullScreen = false
            }else{
              this.isFullScreen = false
            }
            console.log("Updated route on component selection *************** ",route)
            if (push){
              this.$router.push(route)
            }
            let arrLen = this.previouslySelectedReportPagesList.length;
            if(arrLen>0 && this.previouslySelectedReportPagesList[arrLen - 1].component != compName){
              this.previouslySelectedReportPagesList.push({"component":compName,"id":id});
            }
            // this.$emit("changeToSelectedComponent", compName, {})
        },
        close() {
          // this.$emit('close');
          this.isClosed = true
          // this.resetToOldCallback()
          // this.unsetModule({module: "reports"});
          if (Object.keys(this.parentRouteInfo)!=0 && Object.keys(this.parentRouteInfo).includes("name") ){
            this.$router.push({
              name: this.parentRouteInfo.name,
              params:this.parentRouteInfo.params,
              query:Object.assign({}, this.parentRouteInfo.query?this.parentRouteInfo.query:{}),
            })
          }else{
            this.$router.push({
              name: "explorer",
            })
          }
        },
        openFullScreen(type){
          if(type){
              this.isFullScreen = true;
          }else{
              this.isFullScreen = false;
              let arrLen = this.previouslySelectedReportPagesList.length;
              let prevReportPageItem = this.previouslySelectedReportPagesList[arrLen - 2];
              this.changeToSelectedComponent(prevReportPageItem.component, prevReportPageItem.id);
          }
        },
        handleUrlChange(){
          if (!(this.isClosed)){
            let reportsInfo = Utils.getHashLocationForReports()
            if (Object.keys(reportsInfo).length != 0) {
              //No need of writing anything here
            }else{
              this.close()
            }
          }
        },
        changeComponentToAuditTrail(){
          this.changeToSelectedComponent("auditTrail-report","auditTrail");
        },
        changeComponentToStorage(){
          this.changeToSelectedComponent("storage-report","storage");
        },
        changeComponentToIngest(){
          this.changeToSelectedComponent("ingest-report","ingest");
        },
        changeComponentToDownload(){
          this.changeToSelectedComponent("download-report","download");
        },
        changeComponentToArchive(){
          this.changeToSelectedComponent("archive-report", "archive");
        },
        changeComponentToAssetArchiveReport(){
           this.changeToSelectedComponent("archivedAssetReport", "archivedAssetReport");
        },
        changeComponentToRetrieve(){
          this.changeToSelectedComponent("retrieve-report", "retrieve");
        },
        changeComponentToJobs(){
          this.changeToSelectedComponent("jobs-report", "jobs");
        },
        changeComponentToExternalPlugin(id){
          this.changeToSelectedComponent("external-reports-plugin-loader",id);
        },
        changeComponentToDuplicates(){
          this.changeToSelectedComponent("duplicates-report", "duplicates");
        },
        changeComponentToMarkedForDelete(){
          this.changeToSelectedComponent("markedForDelete-report", "markedForDelete");
        },
        changeComponentTodeletedPermanently(){
          this.changeToSelectedComponent("deletedPermanently-report", "deletedPermanently");
        },
        changeComponentToAssetReport(){
          this.changeToSelectedComponent("assets-report", "assets");
        },
        changeComponentToQueryBuilder(){
          this.changeToSelectedComponent("queryBuilder-report", "queryBuilder");
        },
        isPrivilegeExists(priv){
          return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),priv)
        },
        isUserTypeAdministrator(){
          return Utils.isUserTypeAdmin(this.getLoggedInUserType());
        },
        setUpReportsSideMenu(sidchangeComponentToExternalPlugineMenuList){
          for (let sideMenu of sidchangeComponentToExternalPlugineMenuList) {
            if (sideMenu == "auditTrail"){
              let auditTrailEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToAuditTrail,
                "handler_args":[]
              }]
              //new ReportsSidemenu(id, plugin name, label, svg icon, eventLIst)
              let auditTrail = new ReportsSidemenu("auditTrail", "auditTrail", "Audit Trail",Utils.getAuditTrailSvg ,auditTrailEvents)
              auditTrail.register()
            }else if (sideMenu == "storage" && this.isUserTypeAdministrator()){
              let storageEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToStorage,
                "handler_args":[]
              }]
              let storage = new ReportsSidemenu("storage", "storage", "Storage",Utils.getStorageSvg ,storageEvents)
              storage.register()
            }else if (sideMenu == "ingest"){
              let ingestEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToIngest,
                "handler_args":[]
              }]
              let ingest = new ReportsSidemenu("ingest", "ingest", "Ingest",Utils.getIngestSvg ,ingestEvents)
              ingest.register()
            }else if(sideMenu == "download" && this.isPrivilegeExists("Download")){
              let downloadEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToDownload,
                "handler_args":[]
              }]
              let download = new ReportsSidemenu("download", "download", "Download",Utils.getDownloadReportsSvg,downloadEvents)
              download.register()
            }else if(sideMenu == "archive" && this.isPrivilegeExists("Archive")){
              let archiveEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToArchive,
                "handler_args":[]
              }]
              let archive = new ReportsSidemenu("archive", "archive", "Archive",Utils.getArchiveReportsSvg,archiveEvents)
              archive.register()

              let archivedAssets = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToAssetArchiveReport,
                "handler_args":[]
              }]
              let archiveAsst = new ReportsSidemenu("archivedAssetReport", "archivedAssetReport", "Archived Assets",Utils.getArchiveReportsSvg,archivedAssets)
              archiveAsst.register()
            }else if(sideMenu == "retrieve" && this.isPrivilegeExists("Retrieve")){
              let retrieveEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToRetrieve,
                "handler_args":[]
              }]
              let retrieve = new ReportsSidemenu("retrieve", "retrieve", "Retrieve",Utils.getRetrieveSvg,retrieveEvents)
              retrieve.register()
            }else if(sideMenu == "jobs"){
              let jobsEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToJobs,
                "handler_args":[]
              }]
              let jobs = new ReportsSidemenu("jobs", "jobs", "Jobs",Utils.getJobsSvg,jobsEvents)
              jobs.register()
            }else if(sideMenu == "duplicates" && this.isPrivilegeExists("reports") && this.isUserTypeAdministrator()){
              let duplicatesEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToDuplicates,
                "handler_args":[]
              }]
              let duplicates = new ReportsSidemenu("duplicates", "duplicates", "Duplicates",Utils.getDuplicatesReportsSvg,duplicatesEvents)
              duplicates.register()
            }else if(sideMenu == "markedForDelete" && this.isUserTypeAdministrator()){
              let markedForDeleteEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToMarkedForDelete,
                "handler_args":[]
              }]
              let markedForDelete = new ReportsSidemenu("markedForDelete", "markedForDelete", "Marked for delete",Utils.getTrashSvg,markedForDeleteEvents)
              markedForDelete.register()
            }else if(sideMenu == "deletedPermanently" && this.isUserTypeAdministrator()){
              let deletedPermanentlyEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentTodeletedPermanently,
                "handler_args":[]
              }]
              let deletedPermanently = new ReportsSidemenu("deletedPermanently", "deletedPermanently", "Deleted permanently",Utils.getRemoveFromTrash,deletedPermanentlyEvents)
              deletedPermanently.register()
            }else if (sideMenu == "assets"  && this.isUserTypeAdministrator()){
              let assetEvents = [{
                "event_name": "onClick",
                "event_handler": this.changeComponentToAssetReport,
                "handler_args":[]
              }]
              let asset = new ReportsSidemenu("assets", "assets", "Assets",Utils.getFileReportSvg ,assetEvents)
              asset.register()
            }else if(sideMenu == "queryBuilder" && this.isPrivilegeExists("reports")){
              let queryBuilderEvents = [{
                "event_name": "onClick",
                "event_handler":this.changeComponentToQueryBuilder,
                "handler_args":[]
              }]
              let queryBuilder = new ReportsSidemenu("queryBuilder", "queryBuilder", "Custom report",Utils.getQueryBuilderSvg,queryBuilderEvents)
              queryBuilder.register()
            }

            //else if(sideMenu == "storageanalytics"){
            //   let storageanalyticsEvents = [{
            //     "event_name": "onClick",
            //     "event_handler":this.changeComponentToExternalPlugin,
            //     "handler_args":[]
            //   }]
            //   let storageanalytics = new ReportsSidemenu("storageanalytics", "storageanalytics", "storageanalytics",Utils.getDownloadReportsSvg,storageanalyticsEvents)
            //   storageanalytics.register()
            // }
          }
          if(this.isPrivilegeExists("Manage Media Pipeline Reports") && this.getStartUpDataFromInCache().media_pipeline_startup_data && this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage){
            let pipLineReports = this.getStartUpDataFromInCache().media_pipeline_startup_data.media_pipeline_stage;
            for(let pipeline of pipLineReports){
              let storageEvents = [{
                "event_name": "onClick",
                "handler_args":[]
              }]
              let storage = new ReportsSidemenu( pipeline._id, 'pipeline', pipeline.name,Utils.getMediaPipelineReportsSvg ,storageEvents)
              storage.register()
            }
          }
      },
      getEventHandler(eventname,supportedEvents,pluginInfo){
        console.log("clicked",eventname,supportedEvents,pluginInfo);
        // this.selectedPluginInfo = null;
        if(this.sideMenuListIds.includes(pluginInfo.pluginName) && (pluginInfo.pluginName == "storageanalytics" || pluginInfo.pluginName == "metadataanalytics")){
         this.isFullScreen = true;
        }else{
          this.isFullScreen = false;
        }
        
        // if(Object.keys(pluginInfo).length !=0 && pluginInfo.pluginName != "storageanalytics" && pluginInfo.pluginName != "metadataanalytics"){ //if condition is added bcz next line was effectin to select previoulsy selected report page
        //   this.changeToSelectedComponent(pluginInfo.pluginName+"-report", pluginInfo.id);
        // }
        if(pluginInfo && pluginInfo.pluginName == 'pipeline'){
          this.changeToSelectedComponent("pipeline-report",pluginInfo.id);
          return
        }
        if(this.sideMenuListIds.includes(pluginInfo.id)){
          let event = supportedEvents.filter((eventInfo) => eventInfo.event_name == eventname);
            if(event.length != 0){
                return event[0]["event_handler"]();
            }
        }else if(pluginInfo){
          this.selectedPluginInfo = Object.assign({}, pluginInfo);
          return this.changeComponentToExternalPlugin(pluginInfo.id)
        }
      },
        getLicenseErrorMessage(){
          this.getLicensesListFromServer().then((response) => {
            if (Utils.isAcceptedStatusCode(response.statusCode)) {
              if(response.license.length > 0 && 'message' in response.license[0]){
                this.licenseExpMess = response.license[0]["message"]
              }
            }
          });
        },
        
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapActions("settings", ["getLicensesListFromServer"]),
        ...mapGetters("users", ["getLoggedInUserPrivilege","getLoggedInUserType"]),
        ...mapGetters("registry",["getRegisteredReportsSidemenu","unSetReportsSideMenu"]),
        ...mapMutations("locations", ["setLocationHash", "unsetModule","changeLocationCallback", "resetToOldCallback","unsetLocationChangeEventListenerCallback"])
    },
    created() {
      this.getLicenseErrorMessage();
      // this.setLocationHash({type:"reports", module: "reports"})
      // this.changeLocationCallback({callBack: this.handleUrlChange})
      Object.assign(this.parentRouteInfo, this.$route.params.parentinfo?this.$route.params.parentinfo:{})
    },
    mounted(){
      this.setUpReportsSideMenu(this.reportsNavList);
      if (this.$route.params && ((this.$route.params.requestedRoute 
          && Object.keys(this.$route.params.requestedRoute).length != 0 && 
          this.$route.params.requestedRoute.matched[this.$route.params.requestedRoute.matched.length-1].parent.name == "reports") || ('fromDashboard' in this.$route.params && this.$route.params.fromDashboard))){
        let rParams = this.$route.params
        if('subComp' in rParams && rParams.subComp == "pipeline-report"){
          this.changeToSelectedComponent(rParams.subComp, rParams.stageId)
        }else{
          console.log("this.$route.params.requestedRoute.name",this.$route.params.requestedRoute.name,"this.$route.params.requestedRoute.params.pluginId",this.$route.params.requestedRoute.params.pluginId,"this.$route.params.reque");
          this.changeToSelectedComponent(this.$route.params.requestedRoute.name, 
            this.$route.params.requestedRoute.params.pluginId?this.$route.params.requestedRoute.params.pluginId:this.$route.params.requestedRoute.name.split("-")[0]
            , true)
        }
      }else if(this.getRegisteredReportsSidemenu().length !=0){
        let firstPanel = this.getRegisteredReportsSidemenu().filter((panel)=>panel.id=="auditTrail")
        if (firstPanel.length != 0){
          firstPanel = firstPanel[0]
        }else{
          firstPanel = this.getRegisteredReportsSidemenu()[0]
        }
        this.getEventHandler('onClick', firstPanel.onEvents, firstPanel)
      }
    },
    data(){
        return {
            licenseExpMess:undefined,
            selectedComponent: "auditTrail-report",
            activeIndex: "auditTrail",
            showSettings: true,
            userSettings : [],
            selectedPluginInfo:null,
            isClosed : false,
            sideMenuListIds:["auditTrail","storage","ingest","assets","download","archive","retrieve","jobs", "duplicates", "markedForDelete", "deletedPermanently", "storageanalytics","metadataanalytics", "queryBuilder","archivedAssetReport"],
            reportsNavList:["auditTrail","storage","ingest","assets","download","archive","retrieve","jobs", "duplicates", "markedForDelete" , "deletedPermanently", "storageanalytics", "metadataanalytics", "queryBuilder"],
            isFullScreen:false,
            previouslySelectedReportPagesList:[{"component":"auditTrail-report", "id":"auditTrail"}],
            parentRouteInfo:{}
        }
    },
}

</script>


<style scoped lang="scss">
 $border-color: 1px solid #4a4a4a;
    $border-color-only:#4a4a4a;
    $primary-background: #1a1e21;
    $secondary-background-color:#15181B;
    $bg-color-on-hover: #22272b;
    $text-color: #eee;
    $dull-text-color: #757575;
    $secondary-text-color: #9c9c9c;
    $active-blue : #007bff;
    $input-field-and-label-font-size:14px;
    $input-field-height:38px;
    $none-text-color:#4f4f4f;
    $input-field-padding:.375rem 10px;
    $scrollbar-thumb-background:#333;
    $scrollbar-track-background:#1a1e21;
    $scrollbar-thumb-on-hover-background:#555;
    $tags-background-color:#282d31;
    $tags-border-color:#363636;
    $metadata-border-color-on-hover: #5a5a5a;
    $secondary-border-color: 1px solid #2b2b2b;
    $active-green-color:#28a745;
    $svg-color:#666;
    $learn-about-text-color-hover:#b7b327;
    $learn-about-text-color:#9a9620;
    $icon-hover:#2c3339;

.sidebar-menu{
  background: $secondary-background-color;
}
.modal{
      display:block;        
  }

.modal-title{
  margin-top:10px !important;
}
  
  .modal-dialog {
    max-width:100%;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: 100%;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    pointer-events: all;
    background:$primary-background !important;
  }

  .modal-header,.modal-footer{
    border: $secondary-border-color !important;
    background: $secondary-background-color;
}
.modal-header .close {
    // margin: -1rem -13px -1rem auto !important;
    padding:0px;
    margin:0px !important;
}

.modal-header{
  height:65px;
}
.modal-body {
  height:calc(100% - 65px);
  display:inline-block;
  width:100%;

}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}

.activeclass{
    background: $primary-background!important;
  .option-label{
    color: $active-blue !important;
    fill: $active-blue !important;
    svg{
      color: $active-blue !important;
      fill:$active-blue !important;
    }
  }
}

.sidenav{
    height: 100%;
    border-top: none;
    padding: 0px !important;
.sidebar{
    background: $secondary-background-color;
    color: #9c9c9c;
    height:45px;
    padding: 0px 0px 0px 24px !important;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 10px;
    li.sidebar{
      height:40px;
    }
    .option-label{
      color:#9c9c9c;
      font-size: 16px;
    }
}
li.sidebar:hover{
    color: $text-color !important;
    font-weight: 500;
    background: $primary-background!important;
    .option-label{
      color: $text-color !important;
    }
}
}

svg{
  height:15px !important;
  width:15px !important;
  margin-inline-start:4px;
}

.border{
    border: $border-color !important;
}

.close-icon:hover{
  background: $icon-hover;
  border-radius: 20px;
}

</style>